import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export const BarChartAnalysis = ({
  xAxis,
  yAxis,
  series,
  height = 400,
  layout = "vertical",
}) => {
  return (
    <div className="line-chart-container">
      <div className="line-chart">
        <BarChart
          xAxis={xAxis}
          yAxis={yAxis}
          series={series}
          height={height}
          margin={{ left: -10 }}
          skipAnimation={false}
          layout={layout}
          barLabel={(v) => `${v.value}%`}
        />
      </div>
    </div>
  );
};
